<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("offertypes") }}
      </div>
      <div>
        <router-link class="btn-blue" to="offer-types"
          >{{ $t("offertypes") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                name="ot_offer_type"
                v-validate="{ required: 'required', regex: /^[a-zA-Z0-9% ]*$/ }"
                id="ot_offer_type"
                v-model="offerDetails.ot_offer_type"
              />
              <label>{{ $t("offer") }}</label>
            </div>
            <!-- <Tooltip :title="$t('offernameoffertype')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('ot_offer_type')">{{
              errors.first("ot_offer_type")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.marketing_type.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("marketingtype") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.marketing_type"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(
                    marketing_type, marketing_typeIndex
                  ) in marketing_types"
                  :key="marketing_typeIndex"
                  @click="onSelectHandler('marketing_type', marketing_type)"
                  name="selectmarketing_type"
                  id="selectmarketing_type"
                  >{{ marketing_type.mkt_title }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('marketingtypeoffertype')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.marketing_type.length == 0">{{
                $t("marketTypemsg")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="offerDetails.ot_is_active"
                  unchecked-value="N"
                  value="Y"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="offer-types"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";
export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      selected: {
        marketing_type: "",
      },
      offerDetails: {
        marketing_type_id: "",
        ot_offer_type: "",
        ot_is_active: "Y",
        // cinema_name: ""
      },
      mkt_id: "",
      mkt_title: "",
      marketing_types: [],
      Marketing_typeMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_marketing_types",
        urlKey: "marketing_types",
      },
    };
  },
  beforeMount() {
    this.getMarketingList();
  },
  methods: {
    onResetForm: function () {
      this.mkt_id = "";
      (this.offerDetails.ot_offer_type = null),
        (this.selected = {
          marketing_type: "",
        });
    },
    getMarketingList: function () {
      this.marketing_types = [];
      let payload = {
        tableName: "ms_marketing_types",
        mkt_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.marketing_types = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          // console.log("Valid :", valid);
          if (this.selected.marketing_type.length == 0) {
            return;
          } else {
            MarketingService.addOfferType({ ...this.offerDetails })
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);
                  this.onResetForm();
                  if (redirect) {
                    // console.log("redirect value ", redirect);
                    this.$router.push({
                      path: "/marketing/offer-types",
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        }
      });
    },
    onSelectHandler: function (type, value) {
      if (type == "marketing_type") {
        this.offerDetails.marketing_type_id = value.mkt_id;
        this.selected.marketing_type = value.mkt_title;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferComponents/addOfferTypes.vue